// Deprecated types
const DEPRECATED_FRAMES_TYPE = 'frames';
const DEPRECATED_CONTACT_LENSES_TYPE = 'Contact-lenses';
const DEPRECATED_CONTACT_LENS_BUNDLE_TYPE = 'Contact-lens-bundles';
const DEPRECATED_SUNGLASSES_TYPE = 'sunglasses';
const DEPRECATED_SOLUTION_TYPE = 'Solutions';
const DEPRECATED_NON_PRESCRIPTION_BUNDLE = 'nonPrescriptionBundle';
const DEPRECATED_PRESCRIPTION_GLASSES = 'prescriptionGlasses';
// This one isn't updated in the backend yet but should be upper case eventually
const DEPRECATED_CONTACT_LENS_SUBSCRIPTION_TYPE = 'contactLensSubscription';
// New unified attribute types
const FRAMES_TYPE = 'FRAMES';
const CONTACT_LENSES_TYPE = 'CONTACT_LENSES';
const CONTACT_LENS_BUNDLE_TYPE = 'CONTACT_LENS_BUNDLES';
const SUNGLASSES_TYPE = 'SUNGLASSES';
const SOLUTION_TYPE = 'SOLUTIONS';
const NON_PRESCRIPTION_BUNDLE = 'NON_PRESCRIPTION_BUNDLE';
const PRESCRIPTION_GLASSES = 'PRESCRIPTION_GLASSES';
const CONTACT_LENS_SUBSCRIPTION_TYPE = 'CONTACT_LENS_SUBSCRIPTION';
const READY_READERS_TYPE = 'READY_READERS';
const ACCESSORIES_TYPE = 'ACCESSORIES';
const isSubscriptionOrderLineItem = (orderLineItem)=>isSubscriptionProduct(orderLineItem.product)
;
const isSubscriptionProduct = (product)=>product.attributesType === CONTACT_LENS_SUBSCRIPTION_TYPE || product.attributesType === DEPRECATED_CONTACT_LENS_SUBSCRIPTION_TYPE
;
const isContactLenses = (product)=>product.attributesType === CONTACT_LENSES_TYPE || product.attributesType === DEPRECATED_CONTACT_LENSES_TYPE
;
const isContactLensesLineItem = (orderLineItem)=>isContactLenses(orderLineItem.product)
;
const isContactLensesSubscriptionLineItem = (orderLineItem)=>isContactLensesSubscription(orderLineItem.product)
;
const isContactLensBundleLineItem = (orderLineItem)=>isContactLensesBundle(orderLineItem.product)
;
const isContactLensesSubscription = (product)=>product.attributesType === CONTACT_LENS_SUBSCRIPTION_TYPE || product.attributesType === DEPRECATED_CONTACT_LENS_SUBSCRIPTION_TYPE
;
const isFrames = (product)=>product.attributesType === FRAMES_TYPE || product.attributesType === DEPRECATED_FRAMES_TYPE
;
const isContactLensesBundle = (product)=>product.attributesType === CONTACT_LENS_BUNDLE_TYPE || product.attributesType === DEPRECATED_CONTACT_LENS_BUNDLE_TYPE
;
const isDetailContactLenses = (product)=>product.attributesType === CONTACT_LENSES_TYPE || product.attributesType === DEPRECATED_CONTACT_LENSES_TYPE
;
const isDetailContactLensesSubscriptionProduct = (product)=>product.attributesType === CONTACT_LENS_SUBSCRIPTION_TYPE || product.attributesType === DEPRECATED_CONTACT_LENS_SUBSCRIPTION_TYPE
;
const isDetailContactLensesSubscriptionLineItem = (lineItem)=>isDetailContactLensesSubscriptionProduct(lineItem.product)
;
const isPrescriptionGlasses = (product)=>product.attributesType === PRESCRIPTION_GLASSES || product.attributesType === DEPRECATED_PRESCRIPTION_GLASSES
;
const isNonPrescriptionBundle = (product)=>product.attributesType === DEPRECATED_NON_PRESCRIPTION_BUNDLE || product.attributesType === NON_PRESCRIPTION_BUNDLE
;
const isPrescriptionGlassesLineItem = (lineItem)=>isPrescriptionGlasses(lineItem.product)
;
const isNonPrescriptionBundleLineItem = (lineItem)=>isNonPrescriptionBundle(lineItem.product)
;
const isSolutionLineItem = (lineItem)=>isSolution(lineItem.product)
;
const isPrescriptionBundleInArray = (items)=>items.some((item)=>isPrescriptionGlasses(item.product)
    )
;
const isSubscriptionItemInArray = (items)=>items.some((item)=>isContactLensesSubscription(item.product)
    )
;
const isNonPrescriptionBundleInArray = (items)=>items.some((item)=>isNonPrescriptionBundle(item.product)
    )
;
const isDetailContactLensBundles = (product)=>product.attributesType === CONTACT_LENS_BUNDLE_TYPE || product.attributesType === DEPRECATED_CONTACT_LENS_BUNDLE_TYPE
;
const isSunglassesLineItem = (orderLineItem)=>orderLineItem.product.attributesType === SUNGLASSES_TYPE || orderLineItem.product.attributesType === DEPRECATED_SUNGLASSES_TYPE
;
const isSunglasses = (product)=>product.attributesType === SUNGLASSES_TYPE || product.attributesType === DEPRECATED_SUNGLASSES_TYPE
;
const isSolution = (product)=>product.attributesType === SOLUTION_TYPE || product.attributesType === DEPRECATED_SOLUTION_TYPE
;
const isOther = (product)=>product.attributesType === undefined || !CONTACT_LENSES_TYPE || !SOLUTION_TYPE
;
const isReadyReadersLineItem = (orderLineItem)=>orderLineItem.product.attributesType === READY_READERS_TYPE
;
const isReadyReaders = (product)=>product.attributesType === READY_READERS_TYPE
;
const isAccessoriesLineItem = (orderLineItem)=>orderLineItem.product.attributesType === ACCESSORIES_TYPE
;
const isAccessories = (product)=>product.attributesType === ACCESSORIES_TYPE
;

export { isAccessories, isAccessoriesLineItem, isContactLensBundleLineItem, isContactLenses, isContactLensesBundle, isContactLensesLineItem, isContactLensesSubscription, isContactLensesSubscriptionLineItem, isDetailContactLensBundles, isDetailContactLenses, isDetailContactLensesSubscriptionLineItem, isDetailContactLensesSubscriptionProduct, isFrames, isNonPrescriptionBundle, isNonPrescriptionBundleInArray, isNonPrescriptionBundleLineItem, isOther, isPrescriptionBundleInArray, isPrescriptionGlasses, isPrescriptionGlassesLineItem, isReadyReaders, isReadyReadersLineItem, isSolution, isSolutionLineItem, isSubscriptionItemInArray, isSubscriptionOrderLineItem, isSubscriptionProduct, isSunglasses, isSunglassesLineItem };
//# sourceMappingURL=is-product-type.js.map
